import { render, staticRenderFns } from "./dev.vue?vue&type=template&id=9fbfdd5c"
import script from "./dev.vue?vue&type=script&lang=js"
export * from "./dev.vue?vue&type=script&lang=js"
import style0 from "./dev.vue?vue&type=style&index=0&id=9fbfdd5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports